import React from 'react';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import HealingIcon from '@mui/icons-material/Healing';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import FavoriteIcon from '@mui/icons-material/Favorite';
import CheckIcon from '@mui/icons-material/Check';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from 'react-router-dom';

const helpCards = [
	{
		icon: <FitnessCenterIcon sx={{ fontSize: 28 }} />,
		title: 'Poprawa kondycji i sylwetki',
		description: 'Skuteczne metody treningowe dla każdego — niezależnie od poziomu zaawansowania.',
		image: '/photo_6555.jpg',
		gradient: 'linear-gradient(to top, rgba(176,32,68,0.45) 0%, rgba(124,28,57,0.25) 100%)',
	},
	{
		icon: <HealingIcon sx={{ fontSize: 28 }} />,
		title: 'Rozwiązanie problemów bólowych',
		description: 'Kompleksowe wsparcie w pokonywaniu bólu pleców i ograniczeń ruchowych.',
		image: '/photo_6568.jpg',
		gradient: 'linear-gradient(to top, rgba(16,118,101,0.45) 0%, rgba(19,77,68,0.25) 100%)',
	},
	{
		icon: <EmojiEventsIcon sx={{ fontSize: 28 }} />,
		title: 'Treningi pełne energii',
		description: 'Ćwiczenia efektywne i przyjemne — każdy trening będzie interesujący i motywujący.',
		image: '/photo_6541.jpg',
		gradient: 'linear-gradient(to top, rgba(176,32,68,0.45) 0%, rgba(124,28,57,0.25) 100%)',
	},
	{
		icon: <FavoriteIcon sx={{ fontSize: 28 }} />,
		title: 'Budowanie pewności siebie',
		description: 'Szybko zauważysz zmiany w sylwetce i samopoczuciu — efekty, które widać.',
		image: '/photo_6580.jpg',
		gradient: 'linear-gradient(to top, rgba(16,118,101,0.45) 0%, rgba(19,77,68,0.25) 100%)',
	},
];

const personalTraining = [
	'Chcesz nauczyć się bezpiecznie oraz skutecznie trenować',
	'Chcesz osiągnąć wymarzoną sylwetkę',
	'Chcesz poprawić komfort codziennego życia',
	'Chcesz zwiększyć swoją wytrzymałość i siłę',
	'Szukasz motywacji i wsparcia w trakcie treningów',
];

const medicalTraining = [
	'Chcesz bezpiecznie trenować pomimo wady postawy',
	'Masz dosyć bólu i chcesz z nim skończyć',
	'Chcesz wrócić do sprawności po kontuzji',
	'Chcesz poprawić zakres ruchu i elastyczność',
	'Cenisz sobie indywidualne podejście i bezpieczeństwo',
];

export default function TrainingPage() {
	return (
		<div className="pt-20 lg:pt-24">
			<section className="relative py-20 lg:py-28 overflow-hidden bg-gradient-to-br from-gray-50 via-white to-primary-50">
				<div className="absolute inset-0 overflow-hidden pointer-events-none">
					<div className="absolute -top-20 -right-20 w-96 h-96 bg-primary-100/60 rounded-full blur-3xl" />
					<div className="absolute bottom-0 left-10 w-64 h-64 bg-accent-100/40 rounded-full blur-3xl" />
				</div>
				<div className="relative max-w-7xl mx-auto px-6">
					<div className="text-center mb-16">
						<span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 rounded-full text-xs font-bold mb-5 tracking-widest uppercase">
							TRENING
						</span>
						<h1 className="font-playfair-custom-bold text-5xl lg:text-6xl text-gray-900 mb-4">
							Jak mogę Ci <span className="text-gradient">pomóc?</span>
						</h1>
						<p className="text-gray-500 font-montserrat-custom-medium text-lg max-w-xl mx-auto">
							Dobiorę program treningowy dopasowany dokładnie do Twoich potrzeb i celów.
						</p>
					</div>

					<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
						{helpCards.map((card, index) => (
							<div
								key={index}
								className="group relative rounded-3xl overflow-hidden cursor-default"
								style={{ height: '380px' }}
							>
								<div
									className="absolute inset-0 bg-center bg-cover transition-transform duration-700 group-hover:scale-110"
									style={{ backgroundImage: `url(${card.image})` }}
								/>
								<div
									className="absolute inset-0"
									style={{ background: card.gradient }}
								/>
								<div className="absolute inset-0 flex flex-col justify-end p-6 text-white">
									<div className="w-12 h-12 bg-white/15 backdrop-blur-sm rounded-xl flex items-center justify-center mb-4 border border-white/20">
										{card.icon}
									</div>
									<h3 className="font-bold text-lg mb-2 leading-snug">{card.title}</h3>
									<p className="text-white/80 text-sm leading-relaxed font-montserrat-custom-medium">
										{card.description}
									</p>
								</div>
							</div>
						))}
					</div>
				</div>
			</section>

			<section className="py-16 lg:py-24 bg-white">
				<div className="max-w-6xl mx-auto px-6">
					<div className="text-center mb-14">
						<h2 className="font-playfair-custom-bold text-4xl lg:text-5xl text-gray-900">
							Dla kogo są <span className="text-gradient">moje treningi?</span>
						</h2>
					</div>
					<div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
						<div className="relative rounded-3xl overflow-hidden group">
							<div
								className="w-full h-56 bg-center bg-cover transition-transform duration-700 group-hover:scale-105"
								style={{ backgroundImage: 'url(/photo_6555.jpg)' }}
							/>
							<div className="absolute inset-x-0 top-0 h-56 bg-gradient-to-b from-gray-900/60 to-gray-900/20 flex items-center px-8">
								<div>
									<div className="w-12 h-12 bg-gradient-to-br from-primary-500 to-primary-600 rounded-2xl flex items-center justify-center text-white mb-3">
										<FitnessCenterIcon />
									</div>
									<h2 className="font-playfair-custom-bold text-2xl lg:text-3xl text-white">
										Trening personalny
									</h2>
								</div>
							</div>
							<div className="bg-gradient-to-br from-primary-50 to-white p-8">
								<ul className="space-y-3.5">
									{personalTraining.map((item, index) => (
										<li key={index} className="flex items-start gap-3">
											<div className="w-6 h-6 bg-primary-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
												<CheckIcon sx={{ fontSize: 14 }} className="text-white" />
											</div>
											<span className="text-gray-700 font-montserrat-custom-medium">
												{item}
											</span>
										</li>
									))}
								</ul>
								<Link
									to="/contact"
									className="inline-flex items-center gap-2 mt-8 px-6 py-3 bg-gradient-to-r from-primary-500 to-primary-600 text-white font-bold rounded-full shadow-soft hover:shadow-soft-lg hover:scale-105 transition-all duration-300 text-sm"
								>
									ZAPISZ SIĘ
									<ArrowForwardIcon fontSize="small" />
								</Link>
							</div>
						</div>

						<div className="relative rounded-3xl overflow-hidden group">
							<div
								className="w-full h-56 bg-center bg-cover transition-transform duration-700 group-hover:scale-105"
								style={{ backgroundImage: 'url(/photo_6580.jpg)' }}
							/>
							<div className="absolute inset-x-0 top-0 h-56 bg-gradient-to-b from-gray-900/60 to-gray-900/20 flex items-center px-8">
								<div>
									<div className="w-12 h-12 bg-gradient-to-br from-accent-500 to-accent-600 rounded-2xl flex items-center justify-center text-white mb-3">
										<HealingIcon />
									</div>
									<h2 className="font-playfair-custom-bold text-2xl lg:text-3xl text-white">
										Trening medyczny
									</h2>
								</div>
							</div>
							<div className="bg-gradient-to-br from-accent-50 to-white p-8">
								<ul className="space-y-3.5">
									{medicalTraining.map((item, index) => (
										<li key={index} className="flex items-start gap-3">
											<div className="w-6 h-6 bg-accent-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
												<CheckIcon sx={{ fontSize: 14 }} className="text-white" />
											</div>
											<span className="text-gray-700 font-montserrat-custom-medium">
												{item}
											</span>
										</li>
									))}
								</ul>
								<Link
									to="/contact"
									className="inline-flex items-center gap-2 mt-8 px-6 py-3 bg-gradient-to-r from-accent-500 to-accent-600 text-white font-bold rounded-full shadow-soft hover:shadow-soft-lg hover:scale-105 transition-all duration-300 text-sm"
								>
									ZAPISZ SIĘ
									<ArrowForwardIcon fontSize="small" />
								</Link>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section className="relative py-24 lg:py-32 overflow-hidden">
				<div className="absolute inset-0">
					<div
						className="w-full h-full bg-center bg-cover"
						style={{ backgroundImage: 'url(/gym.jpg)' }}
					/>
					<div className="absolute inset-0 bg-gradient-to-r from-gray-900/95 via-gray-900/80 to-primary-900/70" />
				</div>
				<div className="relative max-w-7xl mx-auto px-6">
					<div className="flex flex-col lg:flex-row items-center justify-between gap-12">
						<div className="text-white text-center lg:text-left">
							<h2 className="font-playfair-custom-bold text-4xl lg:text-5xl mb-4">
								Zacznij już dziś!
							</h2>
							<p className="text-lg text-white/80 max-w-xl font-montserrat-custom-light">
								Zapisz się na trening i zacznij swoją drogę do lepszego zdrowia i sylwetki.
							</p>
						</div>
						<div className="flex-shrink-0">
							<Link
								to="/contact"
								className="inline-flex items-center gap-2 px-10 py-5 bg-gradient-to-r from-primary-500 to-primary-600 text-white font-bold rounded-full shadow-soft-lg hover:shadow-card-hover hover:scale-105 transition-all duration-300 text-lg"
							>
								ZAPISZ SIĘ NA TRENING
								<ArrowForwardIcon />
							</Link>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
}
